import { takeLatest, call, put } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { setSending, unsetSending } from '../reducers/serverCommunication';
import {
  setUpdateResourceActivityFailure,
  setUpdateResourceActivityRequest,
  setUpdateResourceActivitySuccess,
} from '../reducers/resourceDataReducer';

export const SAGA_UPDATE_RESOURCE_ACTIVITY = 'SAGA_UPDATE_RESOURCE_ACTIVITY';

export function sendUpdateResourceActivity(payload) {
  return { type: SAGA_UPDATE_RESOURCE_ACTIVITY, payload };
}

const handleUpdateResourceActivity = async ({ resourceId, isLiked, isCompleted, isRecommended }) =>
  axiosInstance
    .put('/api/pop/resources/' + resourceId, {
      isLiked,
      isCompleted,
      isRecommended,
    })
    .then((res) => res.data);

export function* updateResourceActivity(action) {
  yield put(setSending);
  yield put(setUpdateResourceActivityRequest);
  try {
    const response = yield call(handleUpdateResourceActivity, action.payload);
    yield put(setUpdateResourceActivitySuccess(response));
  } catch (error) {
    yield put(setUpdateResourceActivityFailure(error.response));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForUpdateResourceActivity() {
  yield takeLatest(SAGA_UPDATE_RESOURCE_ACTIVITY, updateResourceActivity);
}
